import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core"
import { IconImageService } from "@shared/services/icon-image.service"
import { LanguageResponse } from "@api/communication/models/template"
import { LanguageToIso } from "./language-to-iso"

@Component({
  selector: "ag-communication-language",
  standalone: false,
  templateUrl: "./ag-communication-language.component.html",
  styleUrl: "./ag-communication-language.component.scss",
})
export class AgCommunicationLanguageComponent implements OnInit, OnChanges {
  public checked: boolean = false
  public languageIcon: string
  private languageISO = LanguageToIso
  @Input() language: LanguageResponse
  @Input() defaultLanguage: string
  @Input() hide: boolean = true
  @Output() delete = new EventEmitter<LanguageResponse>()
  @Output() setDefault = new EventEmitter<LanguageResponse>()
  constructor(public iconsService: IconImageService) {}
  ngOnInit(): void {
    if (this?.defaultLanguage === this.language.name) {
      this.checked = true
    }
    var searchString: string = ""
    var languageCode: string = this.language.code
    if (this.language.code.includes("default")) {
      languageCode = this.language.code.replace(" default", "")
    }
    this.languageISO.forEach((value, key) => {
      if (languageCode === key) {
        searchString = `Circle_${value}`
      }
    })
    this.languageIcon = this.iconsService.Icon[searchString]
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultLanguage) {
      this.checked = this.defaultLanguage === this.language.name
    }
  }
  public toggle(): void {
    this.hide = !this.hide
  }
  public setAsDefault(event: any): void {
    this.checked = event ? true : false
    this.setDefault.emit(this.language)
  }
  public deleteLanguage(): void {
    this.delete.emit(this.language)
  }
}
